/**
 * @generated SignedSource<<ca23dd48411b94abe35343bcbc9e4e01>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSupportChat_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"initSupportChat_seller">;
  readonly " $fragmentType": "useSupportChat_seller";
};
export type useSupportChat_seller$key = {
  readonly " $data"?: useSupportChat_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSupportChat_seller">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSupportChat_seller",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "initSupportChat_seller",
      "selections": [
        (v0/*:: as any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "initSierraChat_seller",
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "token",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sfChatToken",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();

(node as any).hash = "965f027714368d8a37efbc7bb20b3d23";

export default node;
